"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMap = exports.CSS = void 0;
const mithril_component_1 = require("../../components/mithril.component");
const theme_1 = require("../../components/theme");
const dom_1 = require("../../dom");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const tag_map_overlay_1 = require("./tag.map.overlay");
exports.CSS = {
    container: 'c-Map',
};
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        width: '100%',
        height: '100%',
    },
});
class TagMap extends mithril_component_1.IMithrilComponent {
    constructor(state) {
        super();
        this.state = state;
    }
    onCreate(vnode) {
        this.map = services_1.Services.Map.attach(vnode.dom);
        this.state.map.setMap(this.map);
        this.map.setMapTypeId('roadmap');
        this.map.set('streetViewControl', true);
        this.overlay = new tag_map_overlay_1.CustomMapOverlay(this.state.map, this.map);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'map:create', 'create', 1);
        this.streetModeListener = this.map.getStreetView().addListener('visible_changed', () => this.trackStreetViewMode());
    }
    onRemove() {
        this.overlay.setMap(null);
        this.streetModeListener.remove();
    }
    onBeforeRemove(vnode) {
        this.overlay.setMap(null);
        this.streetModeListener.remove();
    }
    get nodes() {
        if (!services_1.Services.Map.isReady) {
            return null;
        }
        return (0, mithril_1.m)('div', {
            className: exports.CSS.container,
            onmousemove: dom_1.handleMouseMove,
            onclick: (e) => this.handleMouseClick(e),
        });
    }
    handleMouseClick(e) {
        const node = (0, dom_1.findDragonNode)(e);
        if (node == null) {
            return;
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        const id = node.getAttribute(dom_1.DRAGON_ID);
        const type = node.getAttribute(dom_1.DRAGON_TYPE);
        this.state.map.zoomToId(type, id);
    }
    trackStreetViewMode() {
        const panorama = this.map.getStreetView();
        if (panorama.getVisible()) {
            this.enterTime = Date.now();
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'streetview:enter');
        }
        else {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'streetview:exit', null, Date.now() - this.enterTime);
        }
    }
}
exports.TagMap = TagMap;
//# sourceMappingURL=tag.map.js.map